export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organize your next hiking adventure"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We are a <b>community</b> that helps <b>hikers</b> plan their hiking adventures!"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover trails"])}
}